module.exports = __webpack_public_path__ + "media/images/noun_Info_2746478@2x-7e8dd82a2530a79f21c2d30080700cfc304e7f76310714b8edc1c3e75680e473.png";